import { ref, onMounted, onUnmounted } from 'vue'

export function useNetworkStatus() {
  const isOnline = ref(navigator.onLine)
  const showDialog = ref(false)

  const updateStatus = () => {
    isOnline.value = navigator.onLine
    if (isOnline.value) {
      showDialog.value = false
    } else {
      showDialog.value = true
    }
  }

  const closeDialog = () => {
    showDialog.value = false
  }

  const retryConnection = async () => {
    isOnline.value = true
    showDialog.value = false
  }

  onMounted(() => {
    window.addEventListener('online', updateStatus)
    window.addEventListener('offline', updateStatus)
    if (!isOnline.value) {
      showDialog.value = true
    }
  })

  onUnmounted(() => {
    window.removeEventListener('online', updateStatus)
    window.removeEventListener('offline', updateStatus)
  })

  return {
    isOnline,
    showDialog,
    closeDialog,
    retryConnection
  }
}
